const cache = {};

export function getCache(key) {
  const entry = cache[key];
  if (!entry) return null;

  if (entry.expires < Date.now()) {
    delete cache[key];
    return null;
  }

  return entry.data;
}

export function setCache(key, data, ttlMs = 5 * 60 * 1000) {
  // default 5 mins
  cache[key] = {
    data,
    expires: Date.now() + ttlMs,
  };
}

export async function fetchOnce(key, ttl, fetchFunc) {
  // 1. Read from cache
  const cached = getCache(key);
  if (cached) return cached;

  // 2. Fetch from API
  const data = await fetchFunc();

  // 3. Store
  setCache(key, data, ttl);

  return data;
}
